import React, { useState } from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import routes from 'app/routes';
import { Link } from 'react-router-dom';
import AiCoach from './AiCoach';
import HumanCoach from './HumanCoach';

export default function Index() {
  const [show, setShow] = useState(true);

  const { state: stateUsers } = useUsersContext();

  const score = stateUsers.user.attributes.specific.coaching_readiness_score;

  const closeForm = () => setShow(false);

  const onSkipClick = () => {
    closeForm();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={closeForm}
    >
      {score < 50 ? <HumanCoach score={score} /> : <AiCoach score={score} />}

      <footer className="d-flex justify-content-between">
        <Button
          onClick={onSkipClick}
          variant="outline-primary"
        >
          Learn More
        </Button>
        <Link
          to={score < 50
            ? routes.members.programs.new.index
            : routes.members.programs.new_ai.index}
          className="btn btn-primary"
        >
          {score < 50 ? 'Continue with AI Coach' : 'Build My Program'}
        </Link>
      </footer>
    </Modal>
  );
}
